import { makeObservable, action, observable, computed } from 'mobx';
import { sendCloudwatchRUMError } from '$src/utils/cloudwatchRUM';
import { PAGE_VIEW } from '$src/constants/actions';
import { controlCenterApi } from '../api/control-center-api';

export default class StatsStore {
  pagePath;
  neighborId;

  constructor(rootStore) {
    makeObservable(this, {
      pagePath: observable,
      neighborId: observable,
      pageId: computed,
      locationId: computed,
      setPagePath: action,
      setNeighborId: action,
      sendStats: action,
    });

    this.rootStore = rootStore;
  }

  setPagePath(pagePath) {
    this.pagePath = pagePath;
  }

  setNeighborId(neighborId) {
    this.neighborId = neighborId;
  }

  get locationId() {
    try {
      const pagePathSplitted = this.pagePath.split('/');
      const hasLocationId = pagePathSplitted.length > 3;

      return hasLocationId ? pagePathSplitted[2] : undefined;
    } catch (e) {
      return this.pagePath;
    }
  }

  sendStats = async (userAction = PAGE_VIEW, currentDoorbotId = undefined, pageIdOverride = undefined) => {
    if (!this.neighborId) return;
    try {
      await controlCenterApi.sendStats(this.neighborId, {
        neighborId: this.neighborId,
        locationId: this.locationId,
        pagePath: this.pagePath,
        pageId: pageIdOverride || this.pageId,
        action: userAction,
        doorbotId: currentDoorbotId || '',
        version: process.env.VERSION,
      });
    } catch (e) {
      sendCloudwatchRUMError('Error sending the statistics', e);
    }
  };

  get pageId() {
    try {
      const pagePathSplitted = this.pagePath.split('/');
      let pageId = pagePathSplitted[1];
      const hasSectionPageId = pagePathSplitted.length > 3;

      if (hasSectionPageId) {
        const sectionPageId = pagePathSplitted[pagePathSplitted.length - 1];
        const sectionPageIdCapitalized = sectionPageId[0].toUpperCase() + sectionPageId.slice(1);
        pageId += sectionPageIdCapitalized;
      }

      return pageId
        .replace(/([A-Z])/g, '_$1')
        .trim()
        .toLocaleLowerCase();
    } catch (e) {
      return this.pagePath;
    }
  }
}
